export const RANGE_PRICES = {
  nordicNature: [8787, 9295, 19332],
  nordicElegance: [6903, 8892, 16761],
  willa: [6069, 6587, 12506],
  maalatutSileat: [4919, 5323, 10953],
  maalatutKehys: [5525, 5813, 12382],
  maalatutVedinuralliset: [5644, 5884, 12476],
  puujaViilu: [6410, 6558, 14642],
  melamiiniLaminaatti: [4709, 5185, 10454],
  supermattalaminaatti: [6211, 6360, 13986],
}

export const WORKTOP_PRICES = {
  laminateNordicNature: [766, 1003, 1493],
  laminate: [367, 482, 802],
  granite: [2278, 2764, 4024],
  graniteNordicNature: [2347, 2852, 4213],
  stainless: [1055, 1155, 1733],
}
